import Vue from 'vue'
import { URL_USER_AUTHORIZATION_DOCUMENTS } from '@/constants/urls.js'
import { CURRENT_AUTHORIZATION_DOCUMENTS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [CURRENT_AUTHORIZATION_DOCUMENTS.STATE.AUTHORIZATION_DOCUMENTS]: null
}

const actions = {
  async [CURRENT_AUTHORIZATION_DOCUMENTS.ACTIONS.GET_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_AUTHORIZATION_DOCUMENTS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(CURRENT_AUTHORIZATION_DOCUMENTS.MUTATIONS.GET_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST, resp.data)
  },
  async [CURRENT_AUTHORIZATION_DOCUMENTS.ACTIONS.CREATE_USER_AUTHORIZATION_DOCUMENT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_AUTHORIZATION_DOCUMENTS}`,
      model: model.authorizationDocument
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [CURRENT_AUTHORIZATION_DOCUMENTS.ACTIONS.CLEAR_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST] ({ commit }) {
    commit(CURRENT_AUTHORIZATION_DOCUMENTS.MUTATIONS.CLEAR_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST)
  }
}

const mutations = {
  [CURRENT_AUTHORIZATION_DOCUMENTS.MUTATIONS.GET_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST] (state, authorizationDocuments) {
    state[CURRENT_AUTHORIZATION_DOCUMENTS.STATE.AUTHORIZATION_DOCUMENTS] = authorizationDocuments
  },
  [CURRENT_AUTHORIZATION_DOCUMENTS.MUTATIONS.CLEAR_CURRENT_USER_AUTHORIZATION_DOCUMENT_LIST] (state) {
    state[CURRENT_AUTHORIZATION_DOCUMENTS.STATE.AUTHORIZATION_DOCUMENTS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
